export { Icon as VendorIcon } from '@uigy/generated/vendors.type';

export enum StatusIconType {
  info = 'info',
  negative = 'negative',
  positive = 'positive',
}

export enum StateIndicatorType {
  Connected = 'connected',
  Disconnected = 'disconnected',
  Pending = 'pending',
  Running = 'running',
  Paused = 'paused',
}
